<template>
  <div id="app">
    <ArbitrationGuide />
  </div>
</template>

<script>
import ArbitrationGuide from './components/ArbitrationGuide.vue'

export default {
  name: 'App',
  components: {
    ArbitrationGuide
  }
}
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
